import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import css from "../assets/css.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";

import about1 from "../assets/about1.jpg";
import about2 from "../assets/about2.jpg";
import about3 from "../assets/about3.jpg";
import about4 from "../assets/about4.jpg";
import about5 from "../assets/about5.jpg";
import about6 from "../assets/about6.jpg";

import profile from "../assets/profile.png";
import profile1 from "../assets/profile1.png";

import logo from "../assets/logo.png";
import workinprog from "../assets/workinprog.png";

import amazon from "../assets/amazon.png";

export default {
  email,
  mobile,
  css,
  git,
  html,
  javascript,
  node,
  python,
  react,
  sass,
  typescript,
  about1,
  about2,
  about3,
  about4,
  about5,
  about6,
  profile,
  profile1,
  logo,
  amazon,
  workinprog,
};
